var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_93ebda1b64c53d147d75cea475d7058b",
    "data-name": "93ebda1b64c53d147d75cea475d7058b",
    d: "M8.5,15A6.5,6.5,0,1,0,2,8.5,6.5,6.5,0,0,0,8.5,15Zm2.3-8.8a.65.65,0,0,1,.919.92L8.043,10.8l0,0a.648.648,0,0,1-.919,0l0,0L5.283,8.96A.65.65,0,1,1,6.2,8.041L7.581,9.42,10.8,6.2Z",
    transform: "translate(-2 -2)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFill);
export default __webpack_public_path__ + "static/media/check-fill.feffb83e292aeafd8a7eac43c28e886a.svg";
export { ForwardRef as ReactComponent };